<template>
  <div id="app">
    <b-navbar type="dark" variant="primary" toggle-breakpoint="md" toggleable>
      <b-nav-toggle target="navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"></b-nav-toggle>
      <b-navbar-brand to="/">Shadowtools</b-navbar-brand>
      <b-collapse is-nav id="navbarSupportedContent">
        <b-navbar-nav class="mr-auto">
          <b-nav-item to="/modifiers">Dice Pool Modifiers</b-nav-item>
          <b-nav-item to="/roller">Dice Roller</b-nav-item>
          <!--
          <b-nav-item to="/tracker">Combat Tracker</b-nav-item>
          <b-nav-item to="/salsa">Chunky Salsa Calculator</b-nav-item>
          -->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div id="container" class="container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      title: 'Shadowtools'
    }
  },
  components: {
    // Components go here
  }
}
</script>

<style>
  .navbar { margin-bottom: 25px; }
  .container { padding-bottom: 25px; }
</style>



// WEBPACK FOOTER //
// App.vue?f697cbea